import { Suspense } from 'react';

export const withSuspense = <T extends object>(
  Comp: React.ComponentType<T>,
  props: T = {} as T,
) => {
  return (
    <Suspense fallback={null}>
      <Comp {...props} />
    </Suspense>
  );
};
